import { render, staticRenderFns } from "./Tributacoes.vue?vue&type=template&id=1a9bf1b6"
import script from "./Tributacoes.vue?vue&type=script&lang=js"
export * from "./Tributacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports